import { createRouter, createWebHistory } from 'vue-router'
import TheContainer from '../components/core/Container/TheContainer.vue'
import { i18n } from '../i18n'
import evaluations from './evaluations'
import profile from './profile'
import programs from './programs'
 
 
 

const routes = [
  {
    path: '/',
    name: '',
    component: TheContainer,
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: 'home' */ '../views/Home.vue'),
        meta: {
          title: i18n.global.t('default.home.title') + ' | UG',
          requiresAuth: true,
          uri:'/'
        }
      },
      evaluations,
      {
        path: '/faq',
        name: 'FAQ',
        component: () => import(/* webpackChunkName: 'faq' */ '../views/FAQ.vue'),
        meta: {
          title: i18n.global.t('default.faq.title') + ' | UG',
          requiresAuth: true,
           uri:'/faq'
        }
      },
      {
        path: '/surveys',
        name: 'Surveys',
        component: () => import(/* webpackChunkName: 'surveys' */ '../views/Surveys.vue'),
        meta: {
          title: i18n.global.t('default.surveys.title') + ' | UG',
          requiresAuth: true,
          uri:'/surveys'
        }
      },
      {
        path: '/surveys/:surveyId',
        name: 'SurveyQuestions',
        component: () => import(/* webpackChunkName: 'survey-questions' */ '../views/SurveyQuestions.vue'),
        meta: {
          title: i18n.global.t('default.surveys.title') + ' | UG',
          requiresAuth: true,
          uri:'/surveys'
        }
      },
      {
        path: '/presentations/topics',
        name: 'PresentationTopics',
        component: () => import(/* webpackChunkName: 'presentation-topics' */ '../views/PresentationTopics.vue'),
        meta: {
          title: i18n.global.t('default.presentations.topics.title') + ' | UG',
          requiresAuth: true,
          uri:'/presentations/topics'
        }
      },
      {
        path: '/online-books',
        name: 'OnlineBooks',
        component: () => import(/* webpackChunkName: 'online-books' */ '../views/OnlineBooks.vue'),
        meta: {
          title: i18n.global.t('default.online-books.title') + ' | UG',
          requiresAuth: true,
          uri:'/online-books'
        }
      },
      {
        path: '/grid',
        name: 'Grid',
        component: () => import(/* webpackChunkName: 'grid' */ '../views/Grid.vue'),
        meta: {
          requiresAuth: true,
          uri:'/grid'
        }
      },
      {
        path: '/alert',
        name: 'SweetAlert',
        component: () => import(/* webpackChunkName: 'sweet-alert' */ '../views/SweetAlert.vue'),
        meta: {
          requiresAuth: true,
           uri:'/alert'
        }
      },
      {
        path: '/conversations',
        name: 'Conversations',
        component: () => import(/* webpackChunkName: 'conversations' */ '../views/Conversations.vue'),
        meta: {
          title: i18n.global.t('default.conversations.title') + ' | UG',
          requiresAuth: true,
           uri:'/conversations'
        }
      },
      {
        path: '/multiple-messages',
        name: 'MultipleMessages',
        component: () => import(/* webpackChunkName: 'multiple-messages' */ '../views/MultipleMessages.vue'),
        meta: {
          title: i18n.global.t('default.conversations.title') + ' | UG',
          requiresAuth: true,
           uri:'/multiple-messages'
        }
      },
      {
        path: '/semester-groups',
        name: 'SemesterGroups',
        component: () => import(/* webpackChunkName: 'semester-groups' */ '../views/SemesterGroups.vue'),
        meta: {
          title: i18n.global.t('default.groups.title') + ' | UG',
          requiresAuth: true,
          uri:'/semester-groups'
        }
      },
      {
        path: '/my-students',
        name: 'MyStudents',
        component: () => import(/* webpackChunkName: 'my-students' */ '../views/MyStudents.vue'),
        meta: {
          title: i18n.global.t('default.my-students.title') + ' | UG',
          requiresAuth: true,
          uri:'/my-students'
        }
      },
      {
        path: '/current-students',
        name: 'CurrentStudents',
        component: () => import(/* webpackChunkName: 'current-students' */ '../views/CurrentStudents.vue'),
        meta: {
          title: i18n.global.t('default.students.title') + ' | UG',
          requiresAuth: true,
           uri:'/current-students'
        }
      },
      {
        path: '/edit-profile/:token?',
        name: 'edit-profile',
        component: () => import(/* webpackChunkName: 'edit-profile' */ '../views/EditProfile.vue'),
        meta: {
          title: i18n.global.t('default.profile.title') + ' | UG',
          requiresAuth: true,
           uri:'/edit-profile'
        }
      },
      profile,
      programs,
      
   
      {
        path: '/subjects',
        name: 'subjects',
        component: () => import(/* webpackChunkName: 'subjects' */ '../views/Subjects.vue'),
        meta: {
          title: i18n.global.t('default.subjects.title') + ' | UG',
          requiresAuth: true,
          uri:'/subjects'
        }
      },
      {
        path: '/table',
        name: 'table',
        component: () => import(/* webpackChunkName: 'table' */ '../views/Table.vue'),
        meta: {
          requiresAuth: true,
          uri:'/table'
        }
      },
      {
        path: '/elements',
        name: 'elements',
        component: () => import(/* webpackChunkName: 'elements' */ '../views/Elements.vue'),
        meta: {
          requiresAuth: true,
          uri:'/elements'
        }
      },
      {
        path: '/logout',
        name: 'logout',
        component: () => import(/* webpackChunkName: "logout" */ '../views/Logout'),
        meta: {
          requiresAuth: true,
          uri:'/logout'
        }
      },
      {
        path: '/study-office-information',
        name: 'Studyofficeinformation',
        component: () => import(/* webpackChunkName: "logout" */ '../views/StudyOfficeInformation'),
        meta: {
          requiresAuth: true,
          uri:'/study-office-information'
        }
      },
      {
        path: '/contracts',
        name: 'Contracts',
        component: () => import(/* webpackChunkName: "contracts" */ '../views/Contracts'),
        meta: {
          requiresAuth: true,
          uri:'/contracts'
        }
      },
      {
        path: '/room-booking',
        name: 'RoomBooking',
        component: () => import(/* webpackChunkName: "room-booking" */ '../views/RoomBooking'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('default.room-bookings.title') + ' | UG',
          uri:'/room-booking'
        }
      },
      {
        path: '/publications',
        name: 'Publications',
        component: () => import(/* webpackChunkName: "publications" */ '../views/Publications'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('default.publications.title') + ' | UG',
          uri:'/publications'
        }
      },
      {
        path:'/blog',
        meta: {
          requiresAuth: true,
          uri:'/blog'
          
        },
        beforeEnter(){
          window.location.href='http://blog.ug.edu.ge/ge/all_posts'
        }
      },
      {
        path:'/students',
        name:'Students',
        component: ()=> import('../components/core/SideBar/Students.vue'),
        meta: {
          requiresAuth: true,
          uri:'/students'
          
        },
    
      },
      {
        path:'/lecturers',
        name:'Lectures',
        component: ()=> import('../components/core/SideBar/Lecturers.vue'),
        meta: {
          requiresAuth: true,
          uri:'/lecturers'
          
        },
    
      },
      {
        path:'/program-dates',
        name:'Program dates',
        component: ()=> import('../components/core/SideBar/ProgramDates.vue'),
        meta: {
          requiresAuth: true,
          uri:'/program-dates'
          
        },
    
      },

      {
        path:'/correspondence',
        name:'Correspondence',
        component: ()=> import('../components/core/SideBar/Correspondence.vue'),
        meta: {
          requiresAuth: true,
          uri:'/correspondence'
          
        },
    
    
      }  ,

      {
        path:'/getSyllabuses',
        name:'Get Syllabuses',
        component: ()=> import('../views/Syllabuses'),
        meta: {
          requiresAuth: true,
          uri:'/getSyllabuses'
          
        },
    
    
      } , 

      {
        path: '/syllabusManagement',
        name: '',
        component: () => import( '../views/syllabuses/SyllabusMain.vue'),
        meta: { 
          requiresAuth: true,
          uri:'/syllabusManagement'
        }
      },
      
      
      {
        path: '/syllabusCreate/:syllabusID/:step/:step_week?/:edit_type?/:subjects_calendar_defaultID?/:RatesTypeID?',
        name: '',
        component: () => import( '../views/syllabuses/CreateSyllabus.vue'),
        meta: { 
          requiresAuth: true,
          uri:'/syllabusCreate'
        }
      },

      {
        path:'/computer-exam-setup',
        name:'Computer Exams',
        component: ()=> import('../views/ComputerExamsSetup.vue'),
        meta: {
          requiresAuth: true,
          uri:'/computer-exam-setup'
          
        },
    
    
      } , 

     

      {
        path:'/computer-exam-statistic/:unitID/:semester?',
        name:'Computer Exams Statistic',
        component: ()=> import('../components/computerExamsSetup/ComputerExamsStatistic.vue'),
        meta: {
          requiresAuth: true,
          uri:'/computer-exam-statistic'
          
        },
    
    
      } , 
      {
        path:'/computer-exam-results/:unitID/:subjectID',
        name:'Computer Exams Result',
        component: ()=> import('../components/computerExamsSetup/ComputerExamsResults.vue'),
        meta: {
          requiresAuth: true,
          uri:'/computer-exam-results'
          
        },
    
    
        
      } , 

      {
        path:'/computer-exam-question/:unitID/:subjectID',
        name:'Computer Exams Questions',
        component: ()=> import('../components/computerExamsSetup/ComputerExamQuestions.vue'),
        meta: {
          requiresAuth: true,
          uri:'/computer-exam-question'
          
        },
    
    
        
      } , 


      {
        path:'/createBlock/:unitID/:subjectID',
        name:'Create Blocks',
        component: ()=> import('../components/computerExamsSetup/CreateBlock.vue'),
        meta: {
          requiresAuth: true,
          uri:'/createBlock'
          
        },
    
    
        
      } , 



      {

        path:'/rate-barriers',
        name:'Rate Barriers',
        component: ()=> import('../views/RateBarriers.vue'),
        meta: {
          requiresAuth: true,
          uri:'/rate-barriers'
          
        },
    

         
      }
      , 



      {

        path:'/local-mobility/:studentID',
        name:'Local Mobility',
        component: ()=> import('../views/LocalMobility.vue'),
        meta: {
          requiresAuth: true,
          uri:'/local-mobility'
          
        },
    

         
      },


      {

        path:'/credits-recognition',
        name:'Credits Recognition',
        component: ()=> import('../views/CreditsRecognition.vue'),
        meta: {
          requiresAuth: true,
          uri:'/credits-recognition'
          
        },
    

         
      },
      
      {

        path:'/non-exist-subjects',
        name:'nonExistSubjects',
        component: ()=> import('../components/mobility/NonExistSubjects.vue'),
        meta: {
          requiresAuth: true,
          uri:'/non-exist-subjects'
          
        },
    

         
      },

      {

        path:'/survey-hierarchy',
        name:'survey hierarchy',
        component: ()=> import('../views/SurveyHierarchy.vue'),
        meta: {
          requiresAuth: true,
          uri:'/survey-hierarchy'
          
        },
    

         
      },
      {

        path:'/ug-coins',
        name:'ug coins',
        component: ()=> import('../views/UGCoins.vue'),
        meta: {
          requiresAuth: true,
          uri:'/ug-coins'
          
        },
    

         
      },
      {

        path:'/administration-salary',
        name:'administration salary',
        component: ()=> import('../views/AdministrationSalary.vue'),
        meta: {
          requiresAuth: true,
          uri:'/administration-salary'
          
        },
    

         
      },
      {

        path:'/suspended-contracts',
        name:'suspended contracts',
        component: ()=> import('../views/SuspendedContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/suspended-contracts'
          
        },
    

         
      },
 

      
      {

        path:'/position-departments',
        name:'position departments',
        component: ()=> import('../views/PositionDepartments.vue'),
        meta: {
          requiresAuth: true,
          uri:'/position-departments'
          
        },
    

         
      },


          
      {

        path:'/future-contracts',
        name:'future contracts',
        component: ()=> import('../views/FutureContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/future-contracts'
          
        },
    

         
      },


          
      {

        path:'/contracts-approve',
        name:'contracts approve',
        component: ()=> import('../views/ContractsApprove.vue'),
        meta: {
          requiresAuth: true,
          uri:'/contracts-approve'
          
        },
    

         
      },
      {

        path:'/lecturer-hours-count',
        name:'lecturer hours count',
        component: ()=> import('../views/LecturerHoursCount.vue'),
        meta: {
          requiresAuth: true,
          uri:'/lecturer-hours-count'
          
        },
    

         
      },
      {

        path:'/contract-old',
        name:'contract old',
        component: ()=> import('../views/OldContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/contract-old'
          
        },
    

         
      },
      {

        path:'/hierarchy',
        name:'hierarchy',
        component: ()=> import('../views/Hierarchy.vue'),
        meta: {
          requiresAuth: true,
          uri:'/hierarchy'
          
        },
    

         
      },
      {

        path:'/contract-create/:personID?',
        name:'contract create',
        component: ()=> import('../views/ContractCreate.vue'),
        meta: {
          requiresAuth: true,
          uri:'/contract-create'
          
        },
    

         
      },

      {

        path:'/oldContracts',
        name:'contract old',
        component: ()=> import('../components/contracts/OldContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/oldContracts'
          
        },
    

         
      },
      {

        path:'/expiringContracts',
        name:'expiring Contracts',
        component: ()=> import('../components/contracts/ExpiringContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/expiringContracts'
          
        },
    

         
      },

      {

        path:'/expiredContracts',
        name:'expired Contracts',
        component: ()=> import('../components/contracts/ExpiredContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/expiredContracts'
          
        },
    

         
      },

      {

        path:'/contract-type',
        name:'contract type',
        component: ()=> import('../views/ContractType.vue'),
        meta: {
          requiresAuth: true,
          uri:'/contract-type'
          
        },
    

         
      },

      {

        path:'/contract-template/:contract_typeID',
        name:'contract template',
        component: ()=> import('../components/contracts/ContractTemplate.vue'),
        meta: {
          requiresAuth: true,
          uri:'/contract-template'
          
        },
    

         
      },
      {

        path:'/curator-contracts',
        name:'curator contracts',
        component: ()=> import('../views/CuratorContracts.vue'),
        meta: {
          requiresAuth: true,
          uri:'/curator-contracts'
          
        },
    

         
      },
      {

        path:'/lecturer-loading-time',
        name:'lecturer loading time',
        component: ()=> import('../views/LecturerLoadingTime.vue'),
        meta: {
          requiresAuth: true,
          uri:'/lecturer-loading-time'
          
        },
    

         
      },

      {

        path:'/registrated-persons',
        name:'registrated persons',
        component: ()=> import('../views/RegisteredPersons.vue'),
        meta: {
          requiresAuth: true,
          uri:'/registrated-persons'
          
        },
    

         
      },

      {

        path:'/apwfiles',
        name:'apwfiles',
        component: ()=> import('../views/Apwfiles.vue'),
        meta: {
          requiresAuth: true,
          uri:'/apwfiles'
          
        },
    

         
      },


      {

        path:'/person-taxes',
        name:'person taxes',
        component: ()=> import('../views/PersonTaxes.vue'),
        meta: {
          requiresAuth: true,
          uri:'/person-taxes'
          
        },
    

         
      },


      {

        path:'/register-problems',
        name:'register problems',
        component: ()=> import('../views/RegisterProblems.vue'),
        meta: {
          requiresAuth: true,
          uri:'/register-problems'
          
        },
    

         
      },

      {

        path:'/notes-report',
        name:'notes report',
        component: ()=> import('../views/NotesReport.vue'),
        meta: {
          requiresAuth: true,
          uri:'/notes-report'
          
        },
    

         
      },

      {

        path:'/changes',
        name:'changes',
        component: ()=> import('../views/Changes.vue'),
        meta: {
          requiresAuth: true,
          uri:'/changes'
          
        },
    

         
      },


      {

        path:'/problems',
        name:'problems',
        component: ()=> import('../views/Problems.vue'),
        meta: {
          requiresAuth: true,
          uri:'/problems'
          
        },
    

         
      },

      {

        path:'/BIT_AI',
        name:'BIT_AI',
        component: ()=> import('../views/BIT_AI.vue'),
        meta: {
          requiresAuth: true,
          uri:'/BIT_AI'
          
        },
    

         
      },
       
       
       
       
       
       
 
       
       
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'login' */ '../views/Login.vue'),
    meta: {
      title: i18n.global.t('default.login.authorization') + ' | UG'
    }
  },
  {
    path:'/ticketsQuestionAnswer/:ticketID/:unitID/:subjectID',
    name:'Computer Exams Result',
    component: ()=> import('../components/computerExamsSetup/ForPDF.vue'),
    meta: {
      requiresAuth: true,
      uri:'/ticketsQuestionAnswer'
      
    },


    
  } ,
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: 'reset-password' */ '../views/ResetPassword.vue'),
    meta: {
      title: i18n.global.t('default.login.forgot-password') + ' | UG',
      uri:'/reset-password'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: 'about' */ '../views/About.vue')
  }, 
  
  {

    path:'/details-to-excel/:personID?',
    name:'details to excel',
    component: ()=> import('../components/contracts/DetailsToExcel.vue'),
    meta: {
      requiresAuth: true,
          uri:'/details-to-excel'
      
    },


     
  },
  {

    path:'/printContract/:contractID/:oldPosition?',
    name:'printContract',
    component: ()=> import('../components/contracts/PrintContract.vue'),
    meta: {
      requiresAuth: true,
          uri:'/printContract'
      
    },


     
  }

   
 




 ]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // eslint-disable-next-line no-undef
    if (localStorage.getItem('token')) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
